import { render } from "./Validator.vue?vue&type=template&id=d7ae88d4"
import script from "./Validator.vue?vue&type=script&lang=ts"
export * from "./Validator.vue?vue&type=script&lang=ts"
script.render = render

export default script